<div [class.manage-users]="!embedded" [class.m-auto]="!embedded" [class.mt-5]="!embedded">
  <section [class.card]="!embedded" [class.shadow-sm-darker]="!embedded" [class.mb-4]="!embedded">
    <form #addUser="ngForm" name="addUser" (ngSubmit)="addStudent()" class="mb-0">
      <h3 class="card-header mb-0" *ngIf="!embedded">Add Student</h3>
      <div [class.card-body]="!embedded">
        <div class="fieldset w-100 mb-0">
          <label class="legend" for="email">Enter Email <span class="requiredfield">*</span></label>
          <input type="email" class="text-field" ngModel #email name="email" id="email" required>
          <button type="button" data-toggle="dropdown" aria-expanded="false" title="Adding a student"
            class="position-absolute right-0 top-0 bottom-0 m-auto d-flex align-items-center pr-3 bg-transparent border-0 text-body"><i
              class="fa fa-info-circle"></i></button>
          <div class="info-popup dropdown-menu p-2">
            <p class="form-info-p">The person must already have an account at your school. They join the course straight away and get an email about it. To reach someone without an account, use Invite Student.</p>
          </div>
        </div>
        <div class="fieldset mx-0 my-3" *ngIf="allowBatches">
          <label class="legend">Batch</label>
          <select class="text-field" (change)="setBatchId($event.target.value)">
            <option *ngFor="let batch of batches" [value]="batch.params.id">{{batch.displaytext}}</option>
          </select>
          <button type="button" data-toggle="dropdown" aria-expanded="false" title="Batch"
            class="position-absolute right-0 top-0 bottom-0 m-auto d-flex align-items-center pr-3 bg-transparent border-0 text-body"><i
              class="fa fa-info-circle"></i></button>
          <div class="info-popup dropdown-menu p-2">
            <p class="form-info-p">Which batch the student joins. Their assessment start and due dates come from the batch you pick here.</p>
          </div>
        </div>
      </div>

      <div [class.card-footer]="!embedded" [class.text-center]="embedded" [class.mt-4]="embedded">
        <button type="submit" [disabled]="!addUser.form.valid || saving" class="btn" [class.btn--loading]="saving">Add User</button>
      </div>
    </form>
  </section>
</div>
